import { render } from "./MyBenefitTranslHistory.vue?vue&type=template&id=722dd636"
import script from "./MyBenefitTranslHistory.vue?vue&type=script&lang=js"
export * from "./MyBenefitTranslHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__